export default "__VITE_ASSET__CLSeqaRw__"